import { call, put, takeEvery, takeLatest } from "redux-saga/effects";
import { busXeApi } from "../../../api/bus/busXeApi";
import { IBaseResponeModel } from "../../../models/response/base-response";
import { eBusXeActionTypeIds, IBusXeDeleteStart, IBusXeLoadStart, IBusXeSaveStart } from "../../action-types/bus/IBusXeActionTypes";
import { busXeActions } from "../../actions/bus/busXeActions";

export function* busXeSaga(): any {
	yield takeLatest(eBusXeActionTypeIds.LOAD_START, loadBusXeWorker)
	yield takeEvery(eBusXeActionTypeIds.DELETE_START, deleteBusXeWorker)
	yield takeEvery(eBusXeActionTypeIds.SAVE_START, saveBusXeWorker)
}

function* loadBusXeWorker(action: IBusXeLoadStart): any {
	const res: IBaseResponeModel = yield call([busXeApi, busXeApi.SelectByCoSo], action.payload)
	if (res.is_success) {
		yield put(busXeActions.loadBusXeSuccess(res.data))
	} else {
		yield put(busXeActions.loadBusXeError(res.message || "Không tải được danh sách xe bus"))
	}
}

function* deleteBusXeWorker(action: IBusXeDeleteStart): any {
	const res: IBaseResponeModel = yield call([busXeApi, busXeApi.Delete], action.payload)
	if (res.is_success) {
		yield put(busXeActions.deleteBusXeSuccess())
	} else {
		yield put(busXeActions.deleteBusXeErr(res.message || "Không xoá được xe bus"))
	}
}

function* saveBusXeWorker(action: IBusXeSaveStart): any {
	let res: IBaseResponeModel;
	if (action.payload.id > 0) {
		res = yield call([busXeApi, busXeApi.Update], action.payload);
	} else {
		res = yield call([busXeApi, busXeApi.Insert], action.payload);
	}
	if (res.is_success) {
		yield put(busXeActions.saveBusXeSuccess())
	} else {
		yield put(busXeActions.saveBusXeError(res.message || "Không lưu được xe bus"))
	}
}
